import { render, staticRenderFns } from "./rankingSupplier.vue?vue&type=template&id=4a6f5f62"
import script from "./rankingSupplier.vue?vue&type=script&lang=js"
export * from "./rankingSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports